export default "__VITE_ASSET__9315384f__"